import { Component, OnInit } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';
import { IWizardOptions } from '../../../models';
import { videoProviderSchedulerAliases } from 'common-lib';

import * as _ from 'lodash';
@Component({
    selector: 'wizard-video-provider-display',
    templateUrl: './video-provider-display.component.html',
    styleUrls: ['../../form-styles.scss'],
    providers: [TitleCasePipe]
})
export class VideoProviderDisplayComponent extends BaseComponent implements OnInit {
    private defaultOptionsSubscription: Subscription;
    public videoProvider: IWizardOptions['videoProvider'] | null = null;
    public videoProviderDisplay = '';

    constructor(private wizardService: WizardService, private titleCasePipe: TitleCasePipe) {
        super();
    }

    ngOnInit() {
        this.subscribeToMeetingDefaultsUpdates();
        this.restoreVideoProviderIfExists();
    }

    ngOnDestroy() {
        this.defaultOptionsSubscription.unsubscribe();
    }

    private subscribeToMeetingDefaultsUpdates() {
        this.defaultOptionsSubscription = this.wizardService.onNewDefaultOptions$.subscribe(
            (defaults: IWizardOptions) => {
                if (defaults) {
                    this.videoProvider = defaults.videoProvider;
                    this.videoProviderDisplay = this.createVideoProviderDisplayMessage(this.videoProvider);
                    this.wizardService.updateOptions({ videoProvider: this.videoProvider });
                }
            }
        );
    }

    private restoreVideoProviderIfExists() {
        if (this.wizardService.options.videoProvider) {
            this.videoProvider = this.wizardService.options.videoProvider;
            this.videoProviderDisplay = this.createVideoProviderDisplayMessage(this.videoProvider);
        }
    }

    private createVideoProviderDisplayMessage(videoProvider: IWizardOptions['videoProvider']) {
        if (!videoProvider) {
            return `<em>Video has NOT been enabled for this meeting type</em>`;
        }

        if (videoProvider.type === 'static') {
            return this.createStaticMessage(videoProvider.id);
        } else {
            return this.createDynamicMessage(videoProvider.type);
        }
    }

    private createStaticMessage(url: string) {
        let httpUrl = url;
        if (!_.startsWith(url, 'http')) {
            httpUrl = `http://${url}`;
        }
        return `<a href="${httpUrl}" target="_blank">${url}</a>`;
    }

    private createDynamicMessage(url: string) {
        return `A <strong>${this.titleCasePipe.transform(
            videoProviderSchedulerAliases[url] || url
        )}</strong> link will be added to this meeting`;
    }
}
